import { v4 as uuid }  from 'uuid';
import cloneDeep from 'lodash/cloneDeep';
import { executor } from '@nsr/react-query-builder-executor';
import {
    CONSTANTS,
} from '../components/Helpers/Configuration';
const processSupplementalAssignmentRule = async (suppItem, appValues) => {
    if (suppItem.assignmentRules.assignmentType === CONSTANTS.supplementalAssignmentTypes.always) {
        return true;
    }
    const fn = executor(suppItem.assignmentRules.assignmentQuery);
    const result = await fn(appValues);
    return result;
};
const processSupplementalRequiredRule = async (suppItem, appValues) => {
    if (suppItem.requiredRules.requiredType === CONSTANTS.supplementalRequiredTypes.always) {
        return true;
    }
    if (suppItem.requiredRules.requiredType === CONSTANTS.supplementalRequiredTypes.optional) {
        return false;
    }
    const fn = executor(suppItem.requiredRules.requiredQuery);
    const result = await fn(appValues);
    return result;
};
const simulateAssignSupplementalItems = async (originalApplication, template) => {
    const application = cloneDeep(originalApplication);
    if (template?.supplementalItems?.items && application?.values) {
        application.supplementalItems = [];
        const items = template.supplementalItems.items.filter(it => it.isActive);
        for (let x = 0; x < items.length; x++) {
            const it = items[x];
            const assignItem = await processSupplementalAssignmentRule(it, application.values);
            if (assignItem) {
                const required = await processSupplementalRequiredRule(it, application.values);
                const result = {};
                if (it.itemType === CONSTANTS.supplementalItemTypes.form || it.itemType === CONSTANTS.supplementalItemTypes.formWithUpload) {
                    result.id = uuid();
                    result.status = CONSTANTS.applicationFormStatuses.NOTSTARTED;
                    result.templateId = uuid();
                }
                application.supplementalItems.push({
                    descriptionId: it.descriptionId,
                    id: it.id,
                    itemType: it.itemType,
                    maxUploads: it.maxUploads,
                    nameId: it.nameId,
                    required,
                    supplementalFormId: result.id,
                    supplementalFormStatus: result.status,
                    supplementalTemplateId: result.templateId,
                    waived: it.waived,
                });
            }
        }
    }
    return application;
};
export default simulateAssignSupplementalItems;
